import { createApp } from "vue";
import App from "./App.vue";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

import router from "./router";

import "./css/enterprise-surface.css";
import "./css/pagination-enterprise.css";

// SVG 雪碧图：自动注册 src/assets/icons 下所有 .svg
import "./icons";
import SvgIcon from "@/components/SvgIcon.vue";

import ResizeObserver from "resize-observer-polyfill";

import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

// 仅保留样式导入
import '@eigenpal/docx-editor-vue/styles.css'

dayjs.locale("zh-cn");
window.ResizeObserver = ResizeObserver;

const app = createApp(App);

app.use(Antd);
app.use(router);

// 全局注册 SvgIcon，模板里直接 <SvgIcon name="xxx" />
app.component("SvgIcon", SvgIcon);

app.mount("#app");